import React, { useState, useEffect, useRef } from 'react';

// Lodash Debounce
import debounce from 'lodash.debounce';

// Services
import { searchUsers } from 'services/requests';

// Components
import Autocomplete from 'components/autocomplete';

// ---------------------------------------------------------------------------------------------- \\
// ------------------------------------ SEARCH AND SELECT USER ---------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const SearchAndSelectUser = ({ label, user, setUser }) => {

    const [state, setState] = useState({
        loading: false,
        options: [],
        searchRef: undefined,
    });

    // Effectue une recherche seulement tous les 500ms et non à chaque caractère saisi
    const onSearch = value => {
        setState({ ...state, searchRef: value, loading: true });
    };
    const delayedOnSearch = useRef(debounce(val => onSearch(val), 500)).current;

    function handleDelayedOnSearch(value, reason) {
        if (reason === 'input') {
            delayedOnSearch(value);
        }
    }

    useEffect(() => {
        if (state.loading) {       
            if (state.searchRef.length >= 3) {
                searchUsers({ search: state.searchRef }).then(res => {
                    if (res.status === 200) {
                        setState({
                            ...state,
                            loading: false,
                            options: res.data.data.users.map(u => ({ label: u.fullName + ' (' + u.clientCode + ')', value: u.id })),
                        });
                    }
                    else {
                        setState({ ...state, loading: false });
                    }
                });
            } 
            else {
                setState({ ...state, loading: false });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.loading]);

    return (
        <Autocomplete
            value={user}
            options={state.options}
            loading={state.loading}
            onChange={(e, value) => setUser(value)}
            onInputChange={(e, value, reason) => handleDelayedOnSearch(value, reason)}
            placeholder={label}
        />
    );
};

// Propriétés par défaut
SearchAndSelectUser.defaultProps = {
    label: 'Utilisateur',
};

export default SearchAndSelectUser;
